import React, { useContext, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import _ from 'lodash';

import AppContext from '../../context';
import { createPortfolio } from '../../../api';
import { ReactComponent as Cog } from '../../../assets/icons/cog.svg';
import { ReactComponent as Settings } from '../../../assets/icons/settings.svg';
import { ReactComponent as PlusCircle } from '../../../assets/icons/plus-circle.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import FamilySummary from '../../presentational/dashboard/family_summary/family_summary.component';
import Summary from '../../presentational/summary/summary.component';
import Tracking from '../../presentational/tabs/tracking/tracking.component';
import TopGainersLosersWrapper from '../../presentational/dashboard/top_gainers_losers/top_gainers_losers.wrapper';
import './dashboard.component.css';

const DashboardContainer = (props) => {
  const context = useContext(AppContext);
  const {
    setContext,
    setShowManagePf,
    setShowImportMFs,
    setShowSyncBrokerMF,
    setCurrentPf,
    setManagePfFrom,
  } = props;
  //state
  const [isAddingPf, setIsAddingPf] = useState(false);
  const [addPfError, setAddPfError] = useState(false);

  const getPortfolios = () => {
    let pfs = context.portfolios.filter((pf) => !pf.is_dummy);
    if (pfs.length - 1 === 1) {
      //remove family if single pf
      pfs.splice(0, 1);
    }
    return pfs;
  };

  const showAddPortfolio = () => {
    if (context.is_sample) return false;
    let pfs = context.portfolios.filter(
      (pf) => !pf.is_dummy && pf.id !== 'family',
    );
    if (pfs.length < context.planDetails.ind_portfolio.portfolios) {
      return true;
    }
    return false;
  };

  const onCreatePortfolio = async () => {
    setAddPfError(false);
    setIsAddingPf(true);
    try {
      const name = context.portfolios.find((pf) => pf.is_dummy).name;
      const res = await createPortfolio(name);
      let pfs = _.cloneDeep(context.portfolios);
      const pfIdx = context.portfolios.findIndex((_pf) => _pf.is_dummy);
      pfs[pfIdx] = {
        id: res.data.id,
        name: res.data.title,
        is_empty: true,
        is_mf_eligible_to_sync: true,
        reset_data: 0,
      };
      setManagePfFrom('create_pf');
      setCurrentPf(res.data);
      setContext({ portfolios: pfs });
      setShowManagePf(true);
    } catch (error) {
      setAddPfError(true);
      setIsAddingPf(false);
    }
    setIsAddingPf(false);
  };

  return (
    <>
      <div className="dashboard_summary">
        {getPortfolios().length === 1 ? (
          <>
            <div className="">
              <div className="single_pf_head">
                <h6 className="content-head bold mb-0">My Portfolio</h6>
                <div className="manage_add_btns">
                  {context.planDetails.name !== 'anonymous' && (
                    <div
                      className="manage_pf"
                      onClick={() => setShowManagePf(true)}
                    >
                      <span className="cog_icon">
                        <Cog />
                      </span>
                      <span className="settings_icon">
                        <Settings />
                      </span>
                      Manage
                    </div>
                  )}
                  {showAddPortfolio() ? (
                    <>
                      <button
                        className="create-pf mob-d-none"
                        onClick={() => onCreatePortfolio()}
                      >
                        {isAddingPf ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              color="#0081f2"
                              className="mr-2"
                            />
                            Adding Portfolio
                          </>
                        ) : (
                          <>
                            <span className="plus_circle">
                              <PlusCircle />
                            </span>
                            <span className="plus">
                              <Plus />
                            </span>
                            <span>New Portfolio</span>
                          </>
                        )}
                      </button>
                      {addPfError && (
                        <p className="text-danger">
                          Something went wrong. Please try again
                        </p>
                      )}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="mt-3">
              {getPortfolios().map((pf) => {
                return (
                  <Summary
                    key={pf.id}
                    pf={pf}
                    portfolioId={pf.id}
                    setContext={setContext}
                    setShowManagePf={setShowManagePf}
                    setShowImportMFs={setShowImportMFs}
                    setShowSyncBrokerMF={setShowSyncBrokerMF}
                    setManagePfFrom={setManagePfFrom}
                    setCurrentPf={setCurrentPf}
                    bg={true}
                  />
                );
              })}
            </div>
            {showAddPortfolio() ? (
              <>
                <button
                  className="single_pf create-pf mob"
                  onClick={() => onCreatePortfolio()}
                >
                  {isAddingPf ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        color="#0081f2"
                        className="mr-2"
                      />
                      Adding Portfolio
                    </>
                  ) : (
                    '+ New Portfolio'
                  )}
                </button>
                {addPfError && (
                  <p className="text-danger">
                    Something went wrong. Please try again
                  </p>
                )}
              </>
            ) : null}
          </>
        ) : (
          <>
            <div className="family_pf__cont">
              <div className="family_pf">
                <h6 className="content-head bold">Family</h6>
                <div
                  className="manage_pf"
                  onClick={() => setShowManagePf(true)}
                >
                  <span className="cog_icon">
                    <Cog />
                  </span>
                  <span className="settings_icon">
                    <Settings />
                  </span>
                  Manage
                </div>
              </div>
              <FamilySummary />
            </div>
            <div className="my_portfolios">
              <h6 className="content-head bold">My Portfolios</h6>
              {showAddPortfolio() ? (
                <>
                  <button
                    className="create-pf"
                    onClick={() => onCreatePortfolio()}
                  >
                    {isAddingPf ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          color="#000"
                        />
                        <span>New Portfolio</span>
                      </>
                    ) : (
                      <>
                        <span className="plus_circle">
                          <PlusCircle />
                        </span>
                        <span className="plus">
                          <Plus />
                        </span>
                        <span>New Portfolio</span>
                      </>
                    )}
                  </button>
                  {addPfError && (
                    <p className="text-danger">
                      Something went wrong. Please try again
                    </p>
                  )}
                </>
              ) : null}
            </div>
            {getPortfolios().map((pf) => {
              if (pf.id === 'family') return null;
              return (
                <Summary
                  key={pf.id}
                  pf={pf}
                  setContext={setContext}
                  setShowManagePf={setShowManagePf}
                  setShowImportMFs={setShowImportMFs}
                  setShowSyncBrokerMF={setShowSyncBrokerMF}
                  setManagePfFrom={setManagePfFrom}
                  setCurrentPf={setCurrentPf}
                />
              );
            })}
          </>
        )}
      </div>
      <div className="mb-5 mt-5">
        <TopGainersLosersWrapper />
      </div>
      <div id="gain_loss" className="mb-5 mt-5">
        <Tracking setContext={setContext} />
      </div>
    </>
  );
};

export default DashboardContainer;
